module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/socialProofPlaceCards-d51567766765f65e74ca50c3c9111a67.png";